import React from 'react';
import { Button, ButtonProps } from '@mui/material';

interface AnimatedButtonProps extends ButtonProps {
  glow?: boolean;
}

export const AnimatedButton: React.FC<AnimatedButtonProps> = ({
  children,
  glow = true,
  sx,
  ...props
}) => {
  return (
    <Button
      {...props}
      sx={{
        position: 'relative',
        overflow: 'hidden',
        transition: 'all 0.3s ease',
        ...(glow && {
          '&::after': {
            content: '""',
            position: 'absolute',
            top: '50%',
            left: '50%',
            width: '0%',
            height: '0%',
            borderRadius: '50%',
            background: 'rgba(255, 255, 255, 0.3)',
            transform: 'translate(-50%, -50%)',
            transition: 'width 0.6s, height 0.6s',
          },
          '&:hover::after': {
            width: '300%',
            height: '300%',
          },
        }),
        '&:active': {
          transform: 'scale(0.95)',
        },
        ...sx,
      }}
    >
      {children}
    </Button>
  );
};
